// API instance
import { http } from '@/core/api';

// Either
import { executeRequest } from '@/core/either';
import type { ApiResult } from '@/core/either';

// Types
import type { PostOtpParams } from '../types/otp.type';

export const otpAuthService = {
  /**
   * Envía el OTP a través del canal indicado. Usa el proveedor nuevo.
   * @param data parámetros para obtener el OTP por el canal indicado.
   * @param headers headers opcionales para la petición
   * @returns Promesa con el resultado tipado usando Either (ApiResult<void>).
   */
  createOtpCode(data: PostOtpParams, headers: Record<string, string> = {}): Promise<ApiResult<void>> {
    return executeRequest(() => http.post('auth-server/b2b/otp',
       data, {
        headers,
      }));
  },
};
